export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden>
    <path d="M8 10 L54 7 L57 50 L42 57 L10 56 Z" fill="#FFE45C" stroke="#1F2A44" strokeWidth="3" strokeLinejoin="round" />
    <path d="M42 57 L44 46 L57 50" fill="#F2C94C" stroke="#1F2A44" strokeWidth="3" strokeLinejoin="round" />
    <path d="M16 42 L27 31 L34 37 L46 20" fill="none" stroke="#E4572E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M38 19 L47 19 L47 28" fill="none" stroke="#E4572E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-[30px] leading-none text-[#1F2A44]">ROAS Diary</span>
  </span>
);
